import TreatmentPlan from '../pages/treatmentPlan';
import { Roles, TREATMENT_PLAN_BASE_PATH } from '../constants';

export const treatmentPlanRoutes = [
  {
    path: `${TREATMENT_PLAN_BASE_PATH}/*`,
    type: 'private',
    elem: <TreatmentPlan />,
    roles: [
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.ClientSuccessManager,
      Roles.QaSpecialist,
      Roles.Biller,
      Roles.InvoiceCoordinator,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
    ],
  },
];
